module.exports = __webpack_public_path__ + "files/fcd024e8c961321c228f1950cc75c374.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/skintone-12.png
// module id = 1501
// module chunks = 60